import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # Message
 *
 * Message을 설명하세요.
 */
export const Message = types
  .model('Message')
  // --------------------------------------------------------------------------
  .props({
    content: types.optional(types.string, ''),
    isError: types.optional(types.boolean, false),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model message --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IMessage;
      (Object.keys(newProps) as TMessageKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TMessage = Instance<typeof Message>;
type TMessageSnapshot = SnapshotOut<typeof Message>;

export interface IMessage extends TMessage { }
export type TMessageKeys = keyof TMessageSnapshot & string;
export interface IMessageSnapshot extends TMessageSnapshot { }
export const createMessage = () => types.optional(Message, {} as TMessage);
